/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Compare_Event_Groups_Similarity_TitleInputs */

const en_compare_event_groups_similarity_title = /** @type {(inputs: Compare_Event_Groups_Similarity_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Similarity: ${i?.percent}%`)
};

const fr_compare_event_groups_similarity_title = /** @type {(inputs: Compare_Event_Groups_Similarity_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Similarité : ${i?.percent} %`)
};

const de_compare_event_groups_similarity_title = /** @type {(inputs: Compare_Event_Groups_Similarity_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ähnlichkeit: ${i?.percent}%`)
};

const it_compare_event_groups_similarity_title = /** @type {(inputs: Compare_Event_Groups_Similarity_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Somiglianza: ${i?.percent}%`)
};

const ru_compare_event_groups_similarity_title = /** @type {(inputs: Compare_Event_Groups_Similarity_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Сходство: ${i?.percent}%`)
};

const es_compare_event_groups_similarity_title = /** @type {(inputs: Compare_Event_Groups_Similarity_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Similitud: ${i?.percent}%`)
};

const zh_cn2_compare_event_groups_similarity_title = /** @type {(inputs: Compare_Event_Groups_Similarity_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`相似度：${i?.percent}%`)
};

const ja_compare_event_groups_similarity_title = /** @type {(inputs: Compare_Event_Groups_Similarity_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`類似度: ${i?.percent}%`)
};

const hi_compare_event_groups_similarity_title = /** @type {(inputs: Compare_Event_Groups_Similarity_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`समानता: ${i?.percent}%`)
};

const pt_pt2_compare_event_groups_similarity_title = /** @type {(inputs: Compare_Event_Groups_Similarity_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Similaridade: ${i?.percent}%`)
};

/**
* | output |
* | --- |
* | "Similarity: {percent}%" |
*
* @param {Compare_Event_Groups_Similarity_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_similarity_title = /** @type {((inputs: Compare_Event_Groups_Similarity_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Similarity_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_similarity_title(inputs)
	if (locale === "de") return de_compare_event_groups_similarity_title(inputs)
	if (locale === "it") return it_compare_event_groups_similarity_title(inputs)
	if (locale === "ru") return ru_compare_event_groups_similarity_title(inputs)
	if (locale === "es") return es_compare_event_groups_similarity_title(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_similarity_title(inputs)
	if (locale === "ja") return ja_compare_event_groups_similarity_title(inputs)
	if (locale === "hi") return hi_compare_event_groups_similarity_title(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_similarity_title(inputs)
	return en_compare_event_groups_similarity_title(inputs)
});